import { useEffect, useState } from 'react';
import { useLazyFetchDispatchLegsQuery } from '@api/Trinium/Endpoints/Dispatch/slice';
import { IconButton } from '@mui/material';
import CachedIcon from '@mui/icons-material/CachedTwoTone';
import { useAppDispatch } from '@reduxStore';
import { queueUncontrolledToast } from '@toast';
import { dayjsNow } from '@/Infrastructure/Utilities/dayjs.type';

import styles from '../DataGrid.Dispatch.module.css';

/**
 * Button for triggering a manual refresh of the dispatch leg
 */
export default function RefreshGridButton(props: { terminalNumber: string }) {
	const [refreshTime, setRefreshTime] = useState(dayjsNow());
	const appDispatch = useAppDispatch();
	const [refetch, { isFetching, isError }] = useLazyFetchDispatchLegsQuery();

	useEffect(() => {
		if (!isFetching) {
			setRefreshTime(dayjsNow());
		}
	}, [isFetching]);

	useEffect(() => {
		if (isError) {
			appDispatch(
				queueUncontrolledToast({
					type: 'message',
					message: 'Unable to Refresh Dispatch Legs',
					severity: 'error',
					autoCloseMs: 3000
				})
			);
		}
	}, [isError, appDispatch]);

	return (
		<div
			className={styles['refresh-board-action']}
			title={`Last Refreshed ${refreshTime.format('MM/DD/YYYY HH:mm z')}`}
		>
			<IconButton
				title={`Last Refreshed ${refreshTime.format('MM/DD/YYYY HH:mm z')}`}
				onClick={() => {
					if (!isFetching) void refetch(props.terminalNumber);
				}}
				className={`${styles['icon-btn']} ${styles['refresh-board-btn']}`}
			>
				<CachedIcon className={`${styles['refresh-board-icon']} ${isFetching ? styles.fetching : ''}`} />
			</IconButton>
		</div>
	);
}
